/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantOrgCapabilitiesVmua } from './tenantOrgCapabilitiesVmua';


export interface VmuaTenantProperties { 
    org_id: string;
    org_name?: string;
    org_type?: string;
    restricted?: boolean;
    erp_id?: string;
    capabilities?: TenantOrgCapabilitiesVmua;
}

